import React, { Component } from 'react'
/**
 * 用户中心组件
 */
class HeaderLogo extends Component {
  static defaultProps = {
    currentChannel: null
  }
  render () {
    return (
      <div className='yk-logo'>
        <a href='//www.youku.com' title='Youku 优酷' />
        {
          this.props.currentChannel && this.props.currentChannel.name
            ? <span ref='ChanelName' className='chanel-name'>&bull; {this.props.currentChannel.name}</span> : ''
        }
      </div>
    )
  }
}
export default HeaderLogo
